import React from 'react'
import PropTypes from 'prop-types'
import { times } from 'lodash-es'
import styled from 'styled-components'

const Panes = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction};
  width: 100%;
  height: 100%;
`

const Pane = styled.div`
  display: flex;
  flex: 0 0 50%;
  width: 50%;
`

const PanesComponent = ({
  numberOfPanes = 0,
  direction = 'row',
  renderPane = () => {},
}) => (
  <Panes direction={direction}>
    {times(numberOfPanes, (index) => (
      <Pane key={index}>{renderPane(index)}</Pane>
    ))}
  </Panes>
)

PanesComponent.propTypes = {
  numberOfPanes: PropTypes.number,
  direction: PropTypes.oneOf(['row', 'column']),
  renderPane: PropTypes.func,
}

export default PanesComponent
